import { render } from "./ComponentInstance.vue?vue&type=template&id=9f6e3ab2"
import script from "./ComponentInstance.vue?vue&type=script&lang=js"
export * from "./ComponentInstance.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-content-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__